import React from 'react';

import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const styles = theme => ({
  removeScrollbar: {
    display: 'flex',
    flex: 'auto',
    flexDirection: 'column',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      position: 'relative',
    },
  },
  removeScrollWrap: {
    height: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    flex: '1 1 auto',
    minHeight: 0,
    // Modern CSS to hide scrollbar while keeping scroll functionality
    scrollbarWidth: 'none', // Firefox
    msOverflowStyle: 'none', // IE/Edge
    '&::-webkit-scrollbar': {
      display: 'none', // Chrome, Safari, Opera
    },
  },
  // Show native scrollbar (system default)
  showScrollIndicatorWrap: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    flex: '1 1 auto',
    minHeight: 0,
  },
  paddingBottom: {
    paddingBottom: theme.spacing(3),
  },
  overflowFix: {
    overflow: 'initial',
  },
});

function RemoveScrollbar(props) {
  const {
    classes,
    children,
    paddingBottom,
    className,
    scrollContainerClass,
    style,
    onRef,
    onScroll = () => null,
    showScrollIndicator,
  } = props;

  const scrollClasses = classNames({
    [classes.removeScrollWrap]: !showScrollIndicator,
    [classes.showScrollIndicatorWrap]: showScrollIndicator,
    [classes.paddingBottom]: paddingBottom,
    [scrollContainerClass]: Boolean(scrollContainerClass),
  });

  return (
    <div className={classNames(classes.removeScrollbar, className)} style={style}>
      <div ref={onRef} className={scrollClasses} onScroll={onScroll}>
        {children}
      </div>
    </div>
  );
}

RemoveScrollbar.propTypes = {
  classes: PropTypes.object.isRequired,
  paddingBottom: PropTypes.bool,
  scrollContainerClass: PropTypes.string,
  className: PropTypes.string,
  onRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  style: PropTypes.object,
  onScroll: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  showScrollIndicator: PropTypes.bool,
};

export default withStyles(styles)(RemoveScrollbar);
